import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=3fac3425"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=3fac3425&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports